import { app } from '../../app.module'
/**
 * 投稿タイプアイコン
 * @class PostTypeIcon
 */
class PostTypeIcon {
  private postType: string
  private snsType: string
  private typeText: string
  private typeIcon: string
  private showMediaNo: boolean

  /**
   * 初期化
   */
  public $onInit(): void {
    // タイプをチェックしてスコープにセット
    switch (this.postType) {
      case 'text':
        this.typeText = 'テキスト'
        this.typeIcon = 'mdi-format-text'
        this.showMediaNo = false
        break
      case 'link':
        this.typeText = 'リンク'
        this.typeIcon = 'mdi-link-variant'
        this.showMediaNo = false
        break
      case 'photo':
        this.typeText = '画像'
        this.typeIcon = 'mdi-camera'
        this.showMediaNo = true
        break
      case 'album':
        this.typeText = 'アルバム'
        this.typeIcon = 'mdi-image-album'
        this.showMediaNo = true
        break
      case 'video':
        this.typeText = 'ビデオ'
        this.typeIcon = 'mdi-video'
        this.showMediaNo = false
        break
      case '360-video':
        this.typeText = '360°ビデオ'
        this.typeIcon = 'mdi-radio-tower'
        this.showMediaNo = false
        break
      case 'live-video':
        this.typeText = 'ライブビデオ'
        this.typeIcon = 'mdi-message-video'
        this.showMediaNo = false
        break
      case 'animation-gif':
        this.typeText = 'アニメーションGIF'
        this.typeIcon = 'mdi-movie'
        this.showMediaNo = false
        break
      case 'offer':
        this.typeText = 'クーポン'
        this.typeIcon = 'mdi-ticket'
        this.showMediaNo = false
        break
      case 'note':
        this.typeText = 'ノート'
        this.typeIcon = 'mdi-receipt'
        this.showMediaNo = false
        break
      case 'carousel':
        this.typeText = 'カルーセル'
        this.typeIcon = 'mdi-view-column'
        this.showMediaNo = true
        break
      case 'rich_media':
        this.typeText = 'キャンバス'
        this.typeIcon = 'mdi-bulletin-board'
        this.showMediaNo = false
        break
    }
  }
}

app.component('postTypeIcon', {
  bindings: {
    postType: '@',
    snsType: '@',
    totalMedia: '=',
  },
  template: require('./post-type-icon.pug')(),
  controller: PostTypeIcon,
})
